import React, { Component, Fragment } from 'react';
import { Doughnut } from 'react-chartjs-2';

import DoughnutLabelComponent from 'components/DoughnutLabelComponent';

class DoughnutChart extends Component {
  renderData = () => {
    const { labels, backgroundColor, data } = this.props;
    return {
      labels: labels,
      datasets: [
        {
          data: data,
          borderWidth: 1,
          backgroundColor: backgroundColor,
          hoverBackgroundColor: backgroundColor,
        },
      ],
    };
  };

  renderOptions = () => {
    return {
      responsive: true,
      cutoutPercentage: 80,
      response: true,
      rotation: -2,
      legend: {
        display: false,
      },
      layout: {
        padding: {
          left: 40,
          right: 40,
          top: 40,
          bottom: 40,
        },
      },
    };
  };

  renderLabels = () => {
    const { labels, backgroundColor } = this.props;
    let data = [];
    labels.map((el, index) =>
      data.push({ label: el, color: backgroundColor[index] }),
    );
    return (
      <div className="labels-container">
        {data.map(el => (
          <DoughnutLabelComponent
            key={el.color}
            color={el.color}
            label={el.label}
          />
        ))}
      </div>
    );
  };

  render() {
    return (
      <Fragment>
        <div className="chart-container">
          <Doughnut
            data={this.renderData()}
            options={this.renderOptions()}
            width={100}
            height={100}
          />
        </div>
        {this.renderLabels()}
      </Fragment>
    );
  }
}

export default DoughnutChart;



// WEBPACK FOOTER //
// ./src/components/DoughnutChart/DoughnutChart.js